import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';

const CustomTooltip = ({ id, placement, message }) => {

  return (
    <OverlayTrigger
      target={id}
      placement={placement}
      overlay={(
        <Tooltip id={id}>
          {message}
        </Tooltip>
      )}
    >
      <span className="ml-2">
        <i className="fas fa-info-circle"></i>
      </span>
    </OverlayTrigger>
  );
};

export default CustomTooltip;
